<template>
  <div>
    <div v-if="!instrumentState.data.inst || !instrumentState.db">
      <a class="button is-loading is-text is-large is-fullwidth" style="font-size: 3em;">
      </a>
    </div>
    <router-view v-if="instrumentState.data.inst && instrumentState.db"></router-view>
  </div>
</template>

<script>  
import {fnQueryInstIdData} from '../fn'
/*import {fnSignformatter,
fnHideOnClickOutside,
fnRegreArray,
fnPegaDataUTCNum,
fnTextoEntreTags,
fnFmtData,
fnCampoValidoParaExibicao,
fnDescItem,
fnPegaStatus,
fnPegaStatusChecagem,
fnQueryInstIdData,
fnConfigPeriodicidade} from '../fn'
*/

export default {
  data () {
    return {
      instrumentState: INSTRUMENT_STORE.state
    }
  },
  methods: {
    queryInstIdData: fnQueryInstIdData
  },
  mounted () {
    this.queryInstIdData()
  },
  computed: {
  }
}
</script>

<style scoped>
</style>
